import { Navigate, Outlet, RouteObject, useLocation } from 'react-router';
import {
  AdminAnimation,
  ADMIN_DELIVERIES,
  ADMIN_LOGIN,
  ADMIN_OTP,
  DELIVERIES_COMPLETE_ACCOUNT,
  DELIVERIES_WELCOME,
  isAdmin,
  isDeliveries,
  PARTNER_LOCATIONS_ADD_LOCATION,
  PARTNER_LOCATIONS_BUSINESS_LICENSE,
  PARTNER_LOCATIONS_CONFIRM_LOCATION,
  PARTNER_LOCATIONS_MANUAL_LOCATION,
  PARTNER_LOCATIONS_SELECT_PROVIDERS,
  PARTNER_LOCATIONS_POS_SETUP,
  PARTNER_LOCATIONS_SUCCESS,
  PARTNER_SIGN_UP_ADD_LOCATION,
  PARTNER_SIGN_UP_BUSINESS_LICENSE,
  PARTNER_SIGN_UP_CONFIRM_LOCATION,
  PARTNER_SIGN_UP_MANUAL_LOCATION,
  PARTNER_SIGN_UP_SELECT_PROVIDERS,
  PARTNER_SIGN_UP_POS_SETUP,
  PARTNER_SIGN_UP_SUCCESS,
  PARTNER_SIGN_UP_TERMS,
  PARTNER_SIGN_UP_USER_INFO,
  PARTNER_INTEGRATION_SETUP,
} from '@vgrubs/components';
import { useAuth } from '../../store/auth';
import { AdminAuthLayout } from './AdminLayout/AdminAuthLayout';
import { AdminLayout } from './AdminLayout/AdminLayout';
import { useEffect } from 'react';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const user = useAuth((state) => state.user);

  if (user === null) {
    useAuth.setState({
      user: null,
      tokens: null,
      lastLogoutLayout: {
        date: new Date().toISOString(),
        status: 0,
        error: 'user in local storage is null',
        place: 'layout',
      },
    });
  }

  return user ? <>{children}</> : <Navigate to={ADMIN_LOGIN} />;
}

export const AdminLayoutRoot = ({
  routes,
  sidebarTop,
}: {
  routes: RouteObject[];
  sidebarTop?: React.ReactNode;
}) => {
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (isAdmin) {
      const blackBoxWidget = document.querySelectorAll('blackbox-widget-v3');
      if (
        (location.pathname.startsWith(ADMIN_DELIVERIES) ||
          location.pathname.startsWith(ADMIN_LOGIN) ||
          location.pathname.startsWith(ADMIN_OTP)) &&
        blackBoxWidget
      ) {
        Array.from(blackBoxWidget).forEach((widget: any) => {
          widget.style.visibility = 'hidden';
        });
      } else {
        Array.from(blackBoxWidget).forEach((widget: any) => {
          widget.style.visibility = 'visible';
        });
      }
    }
  }, [location.pathname]);

  if (
    pathname === ADMIN_LOGIN ||
    pathname === ADMIN_OTP ||
    pathname === PARTNER_SIGN_UP_USER_INFO ||
    pathname === PARTNER_SIGN_UP_TERMS ||
    pathname === PARTNER_SIGN_UP_ADD_LOCATION ||
    pathname === PARTNER_SIGN_UP_CONFIRM_LOCATION ||
    pathname === PARTNER_SIGN_UP_BUSINESS_LICENSE ||
    pathname === PARTNER_SIGN_UP_MANUAL_LOCATION ||
    pathname === PARTNER_SIGN_UP_SELECT_PROVIDERS ||
    pathname === PARTNER_SIGN_UP_POS_SETUP ||
    pathname === PARTNER_SIGN_UP_SUCCESS ||
    pathname === PARTNER_LOCATIONS_ADD_LOCATION ||
    pathname === PARTNER_LOCATIONS_CONFIRM_LOCATION ||
    pathname === PARTNER_LOCATIONS_BUSINESS_LICENSE ||
    pathname === PARTNER_LOCATIONS_MANUAL_LOCATION ||
    pathname === PARTNER_LOCATIONS_SELECT_PROVIDERS ||
    pathname === PARTNER_LOCATIONS_POS_SETUP ||
    pathname === PARTNER_LOCATIONS_SUCCESS ||
    pathname === PARTNER_INTEGRATION_SETUP ||
    (isDeliveries &&
      (pathname === DELIVERIES_WELCOME ||
        pathname === DELIVERIES_COMPLETE_ACCOUNT))
  )
    return (
      <AdminAuthLayout
        transparent={
          pathname === PARTNER_SIGN_UP_TERMS || pathname === DELIVERIES_WELCOME
        }
      >
        <AdminAnimation key="admin-layout-auth-outlet">
          <Outlet />
        </AdminAnimation>
      </AdminAuthLayout>
    );

  return (
    <PrivateRoute>
      <AdminLayout routes={routes} sidebarTop={sidebarTop}>
        <AdminAnimation key="admin-layout-outlet">
          <Outlet />
        </AdminAnimation>
      </AdminLayout>
    </PrivateRoute>
  );
};
